<template>
  <div class="container">
    <span id="Watchlist"></span>
    <span id="Watched"></span>
    <div class="box--title">
      <h2 class="title">{{ items_user.visibility }}</h2>
    </div>

    <ith-cards-watchlist />

    <ith-watchlist-grid-detail />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["items_user"]),
  data: () => ({
    parametros: [],
    title: "Watchlist"
  }),

  watch: {
    "items_user.visibility": function() {
      this.items_user.visibility === 0
        ? (this.title = "Watchlist")
        : (this.title = "Watched");
    }
  },

  created() {}
};
</script>

<style scoped>
.box--title {
  display: grid;
  grid-template-columns: repeat(2, auto);
  justify-content: space-between;
  align-items: center;
}
h2 {
  margin: 0px;
}
.title {
  font-size: 35px;
  font-weight: 600;
  padding-top: 35px;
  padding-bottom: 20px;
}

h3 {
  font-weight: 400;
  margin-top: 35px;
}
h3.linea {
  position: relative;
  z-index: 1;
}
h3.linea:before {
  border-top: 1px solid #738092;
  content: "";
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 8%;
  right: 0;
  bottom: 0;
  width: 92%;
  z-index: -1;
}
h3.linea span {
  z-index: 100;
  color: #738092;
  background: #fff;
  padding: 10px 15px;
  /* margin-bottom: 50px!important; */
}

/* @media (max-width: 1904px) {
  .banner--item {
    width: 940px;
    height: 157px;
  }
} */
@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .title {
    margin: 0px 10px;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
  .title {
    margin: 0px 10px;
    padding-top: 0px;
    font-size: 20px;
  }
  .linea {
    margin: 15px 15px;
    font-size: 18px;
  }
  h3.linea:before {
    width: 80%;
    left: 10%;
  }
}

@media (max-width: 600px) {
  .title {
    margin: 0px 10px;
    padding-top: 0px;
    font-size: 20px;
  }
  .linea {
    margin: 15px 15px;
    font-size: 18px;
  }
  h3.linea:before {
    width: 70%;
    left: 25%;
  }
}
</style>
